<template>
  <div class="summary-details" data-testid="task-summary-details">
    <div class="summary-details__header" data-testid="task-summary-details__title">
      Details
    </div>
    <div class="summary-details__body pa-4 d-flex flex-column gap-4">
      <div v-if="task.purpose" class="summary-details__block" data-testid="task-summary-details__purpose">
        <p class="summary-details__label">Purpose</p>
        <p class="summary-details__value">{{ task.purpose }}</p>
      </div>

      <div v-if="task.instruction" class="summary-details__block" data-testid="task-summary-details__instruction">
        <p class="summary-details__label">Instruction</p>
        <p class="summary-details__value">{{ task.instruction }}</p>
      </div>

      <div class="summary-details__grid">
        <div class="summary-details__field" data-testid="task-summary-details__task-type">
          <p class="summary-details__label">Task Type</p>
          <p class="summary-details__value">{{ task.task_type || '—' }}</p>
        </div>
        <div class="summary-details__field" data-testid="task-summary-details__category">
          <p class="summary-details__label">Category</p>
          <p class="summary-details__value">{{ task.category || '—' }}</p>
        </div>
        <div class="summary-details__field" data-testid="task-summary-details__subcategory">
          <p class="summary-details__label">Sub Category</p>
          <p class="summary-details__value">{{ task.subcategory || '—' }}</p>
        </div>
      </div>

      <div class="summary-details__grid">
        <div class="summary-details__field" data-testid="task-summary-details__evidences">
          <p class="summary-details__label">No. of Evidences</p>
          <p class="summary-details__value">{{ task.no_of_evidence ?? '—' }}</p>
        </div>
        <div class="summary-details__field" data-testid="task-summary-details__evidence-required">
          <p class="summary-details__label">Evidence required</p>
          <p class="summary-details__value">{{ evidenceRequiredDisplay }}</p>
        </div>
        <div class="summary-details__field" data-testid="task-summary-details__assertions">
          <p class="summary-details__label">Assertions</p>
          <p class="summary-details__value">{{ assertionsDisplay }}</p>
        </div>
        <div
          v-for="field in customFieldEntries"
          :key="field.key"
          class="summary-details__field"
          :data-testid="`task-summary-details__custom-${field.key}`"
        >
          <p class="summary-details__label">{{ field.label }}</p>
          <p class="summary-details__value">{{ field.value }}</p>
        </div>
      </div>

      <div v-if="tags.length" class="summary-details__block" data-testid="task-summary-details__tags">
        <p class="summary-details__label">Tags</p>
        <div class="summary-details__tags">
          <v-chip
            v-for="(tag, index) in tags"
            :key="`${index}-${tag}`"
            class="summary-details__tag-chip"
            :data-testid="getTagTestId(tag, index)"
          >
            {{ tag }}
          </v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './TaskSummaryDetails.scss';
import { getCustomColumns } from '@/modules/financialclose/utils/utils';

export default {
  name: 'TaskSummaryDetails',

  props: {
    task: { type: Object, required: true },
    isAccountRecon: { type: Boolean, default: false },
  },

  computed: {
    assertions() {
      return Array.isArray(this.task.assertions) ? this.task.assertions : [];
    },
    assertionsDisplay() {
      return this.assertions.length ? this.assertions.join(', ') : '—';
    },
    evidenceRequiredDisplay() {
      return this.task?.evidence_required !== false ? 'Yes' : 'No';
    },
    tags() {
      return Array.isArray(this.task.tags) ? this.task.tags : [];
    },
    customFieldEntries() {
      const schema = this.$store.getters['tasks/getTaskListData']?.customColumnSchema || [];
      return getCustomColumns({}, schema)
        .map((col) => ({
          key: col.columnName,
          label: col.displayText,
          value: this.task[col.columnName],
        }))
        .filter((f) => f.value !== undefined && f.value !== null && f.value !== '');
    },
  },

  methods: {
    getTagTestId(tag, index) {
      const slug = String(tag ?? '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'tag';

      return `task-summary-details__tag-${index}-${slug}`;
    },
  },
};
</script>
